import { useParams } from "react-router-dom";

import ErrorMessage from "@/ui/atoms/ErrorMessage";

import LayoutFillParentCentered from "@/ui/layouts/LayoutFillParentCentered";

import { ViewExtraction } from "@/ui/compositionRootUI";

const PageExtractionMappings = () => {
    const { projectId, databaseId, extractionId } = useParams();

    if (
        projectId === undefined ||
        extractionId === undefined ||
        databaseId === undefined
    ) {
        return (
            <LayoutFillParentCentered>
                <ErrorMessage>Invalid URL parameters</ErrorMessage>
            </LayoutFillParentCentered>
        );
    }

    return (
        <ViewExtraction
            projectId={Number(projectId)}
            databaseId={Number(databaseId)}
            extractionId={Number(extractionId)}
        />
    );
};

export default PageExtractionMappings;
